import React from 'react';
import { Grid, Stack, Box } from '@mui/material';
import PropTypes from 'prop-types';
import logoWV from '../../../static/images/logos/logo-w-vertical.png';
import './header.scss';

function Header({ termsHeader }) {
    return (
        <Grid
            item
            xs={12}
            className={`not-found-logo-grid-container ${termsHeader}`}
        >
            <Stack className="not-found-logo-container">
                <Box>
                    <img
                        className="not-found-logo"
                        src={logoWV}
                        alt="hyphen-logo"
                    />
                </Box>
            </Stack>
        </Grid>
    );
}
Header.propTypes = {
    termsHeader: PropTypes.string,
};
export default Header;
